<template>
    <div>
        <h2 class="hidden lg:block mt-8 mb-2 uppercase font-semibold text-base text-grey-dark">Chart Type</h2>
        <ul class="p-4 flex-row flex-wrap flex list-reset quick">
            <li class="pb-8 pr-2" v-for="foo in chartTypes">
                <button class="bg-white cursor-pointer text-center h-24 w-24 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark focus:outline-none"
                        v-on:click="updateChart(foo)" :class="{'bg-blue-lightest border-blue-lighter': isActive(foo)}">
                    {{ foo.description }}
                </button>
            </li>
        </ul>
    </div>

</template>

<script>

    import store from "../store";

    export default {
        computed: {
            chartTypes: function () {
                return this.$store.state.chartFlip;
            }
        },
        methods: {
            isActive(foo) {
                return foo.swap === this.$store.state.tableSwap;
            },
            updateChart(foo) {
                // dispatch = async action
                this.$store.dispatch('updateTable', foo);
                // commit = sync mutation
            },
        },
    }

</script>